
import { reactive } from 'vue';
import axios from 'axios';

export const authStore = reactive({
  isLoggedIn: false,
  user: null,
  showGlobalLogin: false,
  
  login(userData) {
    this.isLoggedIn = true;
    this.user = userData;
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('isLoggedIn', 'true');
    this.showGlobalLogin = false;
  },
  
  logout() {
    this.isLoggedIn = false;
    this.user = null;
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('username');
    localStorage.removeItem('token_expiry');
  },
  
  async refreshToken() {
    const refresh = localStorage.getItem('refresh');
    if (!refresh) {
      this.logout();
      return false;
    }

    try {
      // 2. Request a new token calling the backend endpoint /api/membership/jwt/refresh/
      const response = await axios.post('/api/membership/jwt/refresh/', { refresh });
      
      // 3. Success Handling: Retrieve the new access token and store it
      const { access } = response.data;
      localStorage.setItem('token', access);
      
      // Set the login state to true
      this.isLoggedIn = true;
      
      // Optional: Store expiry if provided by backend (assuming 24h default if not)
      const expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 24);
      localStorage.setItem('token_expiry', expiryDate.toISOString());

      // Try to restore user data if it was lost from state but exists in storage
      const savedUser = localStorage.getItem('user');
      if (savedUser) this.user = JSON.parse(savedUser);

      return true;
    } catch (error) {
      // 4. Failure Handling: Log the error and clear localStorage
      console.error('JWT Token Refresh failed:', error);
      this.logout();
      return false;
    }
  },

  openLogin() {
    this.showGlobalLogin = true;
  },

  closeLogin() {
    this.showGlobalLogin = false;
  },
  
  async init() {
    const savedStatus = localStorage.getItem('isLoggedIn');
    const hasToken = localStorage.getItem('token');
    const hasRefresh = localStorage.getItem('refresh');

    if (savedStatus === 'true' && hasToken) {
      const savedUser = localStorage.getItem('user');
      try {
        if (savedUser) this.user = JSON.parse(savedUser);
        this.isLoggedIn = true;
      } catch (e) {
        this.logout();
      }
    } else if (hasRefresh) {
      // If we have a refresh token but no active login state, try to refresh
      await this.refreshToken();
    }
  }
});
